import { useFormContext } from 'react-hook-form';
import { RadioField, TextField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryDiagnosedFormValues, IHistoryDiagnosedModel } from '@/types/history/history-diagnosed';

interface IProps {
    model: IHistoryDiagnosedModel;
    t: TLocalize;
}

const RespiratorySection = ({ model, t }: IProps) => {
    const { watch } = useFormContext<IHistoryDiagnosedFormValues>();

    const ms = model.medicalHistoryStatusOptions;
    const yn = model.yesNoUnknownOptions;
    const yes = String(model.yesValue);

    return (
        <>
            <div className='section-heading'>Respiratory</div>

            <RadioField
                name="historyLungDisease"
                label={t('DashLabel_DoYouHaveAHistoryOfLungDisease', 'Do you have a history of lung disease')}
                options={ms}
            />

            {!model.useReducedQuestions && (
                <>
                    <RadioField
                        name="hasCopd"
                        label={t('DashLabel_DoYouHaveAHistoryOfSignificantChronicObstructivePu', 'Do you have a history of significant Chronic Obstructive Pulmonary Disease (COPD)')}
                        options={ms}
                    />
                    <RadioField
                        name="hasTb"
                        label={t('DashLabel_DoYouHaveAHistoryOfTuberculosisTb', 'Do you have a history of Tuberculosis (TB)')}
                        options={ms}
                    />
                    <RadioField
                        name="historyPneumonia"
                        label={t('DashLabel_DoYouHaveAHistoryOfPneumonia', 'Do you have a history of Pneumonia')}
                        options={ms}
                    />
                    <RadioField
                        name="hasRespiratoryIssues"
                        label={t('DashLabel_DoYouHaveAHistoryOfAnyOtherRespiratoryIssues', 'Do you have a history of any other Respiratory issues')}
                        options={yn}
                        help={t('DashLabel_RespiratoryIssueChoices', 'e.g. Asthma, chronic bronchitis')}
                    />
                    {watch('hasRespiratoryIssues') === yes && (
                        <div className="sub-question">
                            <TextField
                                name="respiratoryIssuesDescription"
                                label={t('DashLabel_WhatRespiratoryIssues', 'What respiratory issues')}
                                maxLength={128}
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default RespiratorySection;
